/* eslint-disable react-hooks/exhaustive-deps */
import { Paper } from "@mui/material";
import { Location } from 'history'
import { FC, useCallback, useEffect, useMemo, useState } from "react"
import { useHistory, Prompt } from "react-router-dom";
import { DEFAULT_PROJETO_OFFGRID, POSICAO_MODULO, NOME_CLIENTE_MAX_LENGTH } from "src/components/projetos/constants";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import { apiNoLoading, STATUS_CODE } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { EquipeType } from "src/providers/cadastros/ContaProvider/types";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { getCidades, getEstados, getDistribuidoresPorTipoDeConta, getRevendas, distribuidoresPorTipoDeConta$, revendas$, getEstadosServico, getRegioes, regioes$, estadosServico$, getDistribuidores, verificarSegmentoConta } from "src/store/global.store";
import { Regiao } from "src/types";
import { ListUtil } from "src/framework/commons/ListUtil";
import { FormProjetoOffGridType, ListagemItem, ProjetoTipoType } from "../types";
import { FormDadosOffGrid } from "./FormDadosOffGrid";
import { InformationDrawerOffGrid } from "../InformationDrawerOffGrid";
import { getLatLng } from "react-places-autocomplete";
import { debounce } from "lodash";
import { ProjetosOffGridProvider } from "src/providers/ProjetosOffGridProvider";
import { OFFGRID_ERROR_MESSAGES, oldEstruturas$, useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store";
import { elSemEstrutura } from "../dimensionados_offgrid/containers/modalEditarEstruturas";
import { calcularEstruturas } from "../dimensionados_offgrid/utils/calcularEstruturas";
import { buscarEstruturasPorModulo } from "../dimensionados_offgrid/utils/buscarEstruturasPorModulo";
import { calcularAcessorios } from "../dimensionados_offgrid/utils/calcularAcessorios";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { calcularPotenciaEquipamentosOffGrid } from "../utils/calcularPotenciaEquipamentosOffGrid";
import { ACESSORIOS_MANTIDOS_EDICAO } from "../dimensionados_offgrid/containers/solucao";
import { notifierStore } from "src/framework/store/NotifierStore";
import { ContaProvider } from "src/providers/cadastros/ContaProvider";
import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider";
import { manualLoading$ } from "src/framework/store/ApiEvents";
import { safeGeocodeByAddress } from "src/framework/commons/MapsUtil";

interface GetLatLngFromAddressType {
  cep: string;
  cidadeNome: string;
  estadoId: string;
}

const TITULO_MAX_LENGTH = 100

const projetosProvider = new ProjetosProvider();
const contasProvider = new ContaProvider();
const projetosOffGridProvider = new ProjetosOffGridProvider()
const componenteProvider = new ComponenteProvider();

const initLoad = async () => {
  await Promise.all([
    getEstados(),
    getRegioes(),
    getCidades(),
    getDistribuidores(),
    getDistribuidoresPorTipoDeConta(),
    getRevendas(),
    getEstadosServico({ force: true }),
  ])
}

export const ProjetosFormInicialOffGrid: FC = () => {
  const projetosOffGridState = useProjetosOffGridStore(store => store.state.data)
  const projetosOffGridModalsState = useProjetosOffGridStore(store => store.state.modals)
  const projetosOffGridActions = useProjetosOffGridStore(store => store.actions)
  const projetosOffGridValidationsStoreState = useProjetosOffGridStore(store => store.state.validations);

  const history = useHistory<{ allowAccess?: boolean; noReset?: boolean; done?: boolean; tipo?: ProjetoTipoType }>();
  const regioes = useObservable(regioes$)
  const revendasState = useObservable(revendas$);
  const estadosServico = useObservable(estadosServico$);

  const [errorState, setErrorState] = useState<string[]>([]);
  const [checkSegmentoConta, setCheckSegmentoConto] = useState<boolean>(false);
  const [distribuidorRevendaUsuario, setDistribuidorRevendaUsuario] = useState<any>(null);
  const [oldFormState] = useState(DEFAULT_PROJETO_OFFGRID)
  const oldEstruturas = useObservable(oldEstruturas$);
  
  const canNavigate = useCallback((location: Location | null = null)=>{
    const allowedLocations = ['/projetos/.*/novo', 'edicao$', 'clonar$']
    const localLocation = location || history.location

    const loc = localLocation as Location<{ done: boolean }>

    return loc.state?.done || allowedLocations.some(item => {
      return loc?.pathname.match(new RegExp(item))
    })
  },[history.location])

  useEffect(() => {
    return () => {
      if (!canNavigate()) {
        projetosOffGridActions.reset()
      }
    }
  },[canNavigate, history, projetosOffGridActions])

  const init = useCallback(()=>{
    const _distribuidorRevendaUsuario: any = LocalStorage.get("solar.userExtraInfo", true)
    setDistribuidorRevendaUsuario(_distribuidorRevendaUsuario)
  },[])

  useEffect(() => {
    initLoad().then(() => {
      init()
    })
  }, [init]);

  useEffect(()=>{
    if (!checkSegmentoConta) {
      if (projetosOffGridState?.distribuidor_id) {
        verificarSegmentoConta({ 
          goBack: true,
          segmento: projetosOffGridState?.segmento ||'off', 
          revendaId: projetosOffGridState?.revenda_id || projetosOffGridState?.revenda?.id || undefined, 
          distribuidorId: projetosOffGridState?.distribuidor_id || projetosOffGridState?.distribuidor?.id || undefined
        });
        setCheckSegmentoConto(true);
      } else if (!projetosOffGridState?.isEdit) {
        verificarSegmentoConta({ segmento: 'off', goBack: true });
        setCheckSegmentoConto(true);
      }
    }
  },[projetosOffGridState, checkSegmentoConta]);

  const onClickNext = useCallback((state: FormProjetoOffGridType)=>{
    projetosOffGridActions.changeValue(state)

    const urlsFromTipo: {[index: string]: string} = {
      dimensionado: '/projetos/offgrid/dimensionados/novo',
    }
    
    const urlsFromTipoEdicao: {[index: string]: string} = {
      dimensionado: `/projetos/${state.id}/offgrid/dimensionados/edicao`,
    }

    const urlsFromTipoClonar: {[index: string]: string} = {
      dimensionado: `/projetos/${state.id}/offgrid/dimensionados/clonar`,
    }

    if (urlsFromTipo[state.tipo]) {
      if (state.clonar_projeto) {
        history.push(urlsFromTipoClonar[state.tipo], { allowAccess: true })
        return
      }
      
      if (state.isEdit) {
        history.push(urlsFromTipoEdicao[state.tipo], { allowAccess: true })
        return
      }
      history.push(urlsFromTipo[state.tipo], { allowAccess: true })
    }
  },[history, projetosOffGridActions])

  const validate = useCallback(() => {
    const _errorState = [...errorState]
    const messages: string[] = [];

    const data = {...projetosOffGridState}

    if (!data?.cliente_proposta){
      messages.push("O campo nome do cliente é obrigatório");
      _errorState.push("cliente_proposta")
    }

    if (data?.cliente_proposta && data?.cliente_proposta.length > NOME_CLIENTE_MAX_LENGTH) {
      messages.push(`O campo nome do cliente deve ter no máximo ${NOME_CLIENTE_MAX_LENGTH} caracteres`);
      _errorState.push("cliente_proposta")
    }

    if (data?.titulo && data?.titulo?.length > TITULO_MAX_LENGTH) {
      messages.push("O campo título deve ter no máximo 100 caracteres");
      _errorState.push("titulo")
    }

    if (!data?.cidade) {
      messages.push("O campo cidade é obrigatório");
      _errorState.push("cidade_id")
    }

    if (!data?.distribuidor_id && !data?.distribuidor?.id) {
        messages.push("O campo distribuidor é obrigatório");
        _errorState.push("distribuidor_id")
    }



    if(data?.email_proposta){
      if (!ValidateUtil.isValidEmail(data?.email_proposta)) {
        messages.push("E-mail inválido");
        _errorState.push("email_proposta")
      }else{
        ListUtil.removeItem(_errorState, "email_proposta")
      }
    }else{
      ListUtil.removeItem(_errorState, "email_proposta")
    }

    if (messages.length > 0) {
      setErrorState(_errorState)
      notifierStore.setNotifier({
          title: "Aviso",
          content: messages,
          timeOut: 3500,
          onClose: () => {
              notifierStore.setOpen(false)
          }
      })
      notifierStore.setOpen(true)
    }

    return messages.length === 0;
  }, [errorState, projetosOffGridState])

  const mostrarOpcaoServico = useMemo(()=>{
    if (!projetosOffGridState?.estado?.id) return true;
    const reg = regioes?.data || []
    const estadosPermitemServico: string[] = (estadosServico?.data || []).map((item: any) => item.regiao_id)
    const currentRegioes: string[] = reg.filter((item: Regiao) => {
      if (!item.estados || item.estados.length === 0) return false;
      const ids = item.estados.map((estado: any) => estado.estado_id)
      return ids.includes(projetosOffGridState.estado?.id)
    }).map((item: any) => item.id)
    return estadosPermitemServico.some(item => {
      if (currentRegioes.includes(item)) return true;
      return false;
    })
  },[regioes, projetosOffGridState?.estado, estadosServico])

  const captureData = useCallback(async(data: any) => {
    if (!validate()) return

    const state = { ...data };

    const distribuidores = distribuidoresPorTipoDeConta$.getValue();

    if (state?.distribuidor === undefined) {
      const idxDistribuidor = distribuidores.data.findIndex((d: any) => d.id === distribuidorRevendaUsuario?.distribuidor_id)
      if (idxDistribuidor > -1) {
        state.distribuidor = distribuidores.data[idxDistribuidor]
      }
    }

    if (state?.revenda === undefined) {
      const idxRevenda = revendasState?.data.findIndex((d: any) => d.id === distribuidorRevendaUsuario?.revenda_id)
      
      if (idxRevenda > -1) {
        state.revenda = revendasState.data[idxRevenda]
      } else {
        if (distribuidorRevendaUsuario?.revenda_id && distribuidorRevendaUsuario?.revenda_nome && distribuidorRevendaUsuario?.revenda_cnpj_cpf) {
          state.revenda = {
            id: distribuidorRevendaUsuario.revenda_id,
            nome: distribuidorRevendaUsuario.revenda_nome,
            cnpj_cpf: distribuidorRevendaUsuario.revenda_cnpj_cpf,
          }
        }
      }
    }

    const cpfCnpjDistribuidor = state?.distribuidor?.cnpj_cpf;

    if (!state?.codigo_venda) {
      if (cpfCnpjDistribuidor === "" || cpfCnpjDistribuidor === undefined || cpfCnpjDistribuidor === null) {
        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: "Distribuidor não informado ou CNPJ inválido!",
            timeOut: 3000,
            onClose: () => {
                notifierStore.setOpen(false);
            }
        })
        notifierStore.setOpen(true);
        return;
      }
    }

    const hasRevenda = !!state?.revenda;

    if ((oldFormState?.distribuidor?.id !== state?.distribuidor?.id) || (oldFormState?.distribuidor?.id === state?.distribuidor?.id && hasRevenda && oldFormState?.revenda?.id !== state?.revenda?.id)) {
      let codigoDistribuidorRevenda = state?.distribuidor?.id;
      
      if (hasRevenda) {
          codigoDistribuidorRevenda = state?.revenda?.id;
      }

      const responseEquipe: EquipeType | null = await contasProvider.getEquipe(codigoDistribuidorRevenda, state.segmento, apiNoLoading);

      state.ev_id = responseEquipe?.ev_id;
      state.supervisor_id = responseEquipe?.supervisor_id;
      state.assistente_id = responseEquipe?.assistente_id;
    }
    
    state.distribuidor_id = state?.distribuidor?.id;
    state.cidade_id = state?.cidade?.id;
    state.estado_id = state?.estado?.id;
    
    return state;
  },[distribuidorRevendaUsuario, revendasState, oldFormState?.distribuidor?.id, oldFormState?.revenda?.id, validate])

  useEffect(() => {
    if (distribuidorRevendaUsuario && !projetosOffGridState?.distribuidor?.id) {
          const projetoPayload: Partial<FormProjetoOffGridType> = {}

          if (!distribuidorRevendaUsuario.isIntelbras) {
            Object.assign<Partial<FormProjetoOffGridType>, Partial<FormProjetoOffGridType>>(projetoPayload, { distribuidor_id: distribuidorRevendaUsuario?.distribuidor_id })

            const distribuidores = distribuidoresPorTipoDeConta$.getValue().data
            const distribuidorIdx = distribuidores.findIndex((d) => d.id === projetosOffGridState.distribuidor_id)
            if (distribuidorIdx > -1) {
              Object.assign<Partial<FormProjetoOffGridType>, Partial<FormProjetoOffGridType>>(projetoPayload, { distribuidor: distribuidores[distribuidorIdx] })
            }

            if (distribuidorRevendaUsuario?.revenda_id) {
              Object.assign<Partial<FormProjetoOffGridType>, Partial<FormProjetoOffGridType>>(projetoPayload, { revenda_id: distribuidorRevendaUsuario?.revenda_id })
                const revendas = revendas$.getValue().data;
                const revendaIdx = revendas.findIndex((r) => r.id === projetosOffGridState.revenda_id)
                if (revendaIdx > -1) {
                  Object.assign<Partial<FormProjetoOffGridType>, Partial<FormProjetoOffGridType>>(projetoPayload, { revenda: revendas[revendaIdx] })
                }
            }

            projetosOffGridActions.changeValue(projetoPayload)

            verificarSegmentoConta({ 
              goBack: true,
              segmento: 'off', 
              revendaId: distribuidorRevendaUsuario?.revenda_id || undefined, 
              distribuidorId: distribuidorRevendaUsuario?.distribuidor_id || undefined
            });
          }
      }

  }, [distribuidorRevendaUsuario, projetosOffGridActions, projetosOffGridState.distribuidor_id, projetosOffGridState.revenda_id, projetosOffGridState?.distribuidor?.id]);

  const getLatLngFromAddress = useCallback((payload: GetLatLngFromAddressType) => {
    const { cidadeNome, estadoId } = payload;
    if (!estadoId || !cidadeNome) return;
    const endereco = `, , , ${cidadeNome},${estadoId}, `
    safeGeocodeByAddress(endereco)
    .then(res => getLatLng(res[0])).then(async ({lat, lng}) => {
      projetosOffGridActions.changeValue({ latitude: lat, longitude: lng })
    }).catch(err => {
      projetosOffGridActions.changeValue({ latitude: 0, longitude: 0 })
      notifierStore.setNotifier({
          title: "Aviso",
          content: "Não foi possível obter a localização a partir do endereço fornecido.",
          timeOut: 3500,
          onClose: () => {
              notifierStore.setOpen(false)
          }
      })
      notifierStore.setOpen(true);
    })
  },[projetosOffGridActions])

  const getLatLngFromAddressDebounced = useCallback(
    debounce((payload: GetLatLngFromAddressType) => {
      getLatLngFromAddress(payload)
    }, 800),
    []
  );

  useEffect(() => {
    if (!projetosOffGridState?.estado?.id || !regioes?.data || regioes?.data.length === 0) return;

    const localRegioes = regioes.data || []
    const projetosRegioes = localRegioes.filter((regiao: any) => {
      const estadosList = regiao.estados || []
      const estados = estadosList.map((item: any) => item.estado_id)
      return estados.includes(projetosOffGridState?.estado?.id)
    })

    projetosOffGridActions.changeValue({
      regioes: projetosRegioes.map((item: Regiao) => item.id),
    })
  },[projetosOffGridActions, projetosOffGridState?.estado?.id, regioes?.data])

  useEffect(()=>{
    if (!projetosOffGridState.total_consumo_diario_w || !projetosOffGridState.latitude || !projetosOffGridState.longitude) return;

    projetosOffGridProvider.calcularGeracaoNecessaria({
      consumo_diario: projetosOffGridState.total_consumo_diario_w,
      latitude: projetosOffGridState.latitude,
      longitude: projetosOffGridState.longitude,
    }).then(async (response) => {

      if (response.statusCode !== STATUS_CODE.OK) {
        notifierStore.setNotifier({
          content: response.message || "Erro ao calcular geração necessária.",
          onClose: () => notifierStore.setOpen(false),
          timeOut: 4000,
          title: "Atenção"
        })

        notifierStore.setOpen(true)
        return;
      }

      projetosOffGridActions.changeValue({
        geracao_necessaria_w: Number(Number(response.data?.potencia || 0).toFixed(3)),
        geracao_necessaria_kw: Number(Number((response.data?.potencia || 0) / 1000).toFixed(3)),
      })
    }).catch(() => projetosOffGridActions.changeValue({ geracao_necessaria_w: 0, geracao_necessaria_kw: 0 }))
  },[projetosOffGridActions, projetosOffGridState.latitude, projetosOffGridState.longitude, projetosOffGridState.total_consumo_diario_w])

  useEffect(() => {
    if (!projetosOffGridState.geracao_necessaria_kw || !projetosOffGridState.regioes.length) return;

    componenteProvider.buscarModulosPorRegiao(
      projetosOffGridState.regioes.map(String), 
      Number(projetosOffGridState.geracao_necessaria_kw),
      undefined,
      undefined,
      undefined,
      undefined,
      "off",
    ).then(response => {
      projetosOffGridActions.addModulos(response)
    }).catch((err) => {
      //TO DO: Verificar tratamento de erro
    })

  }, [projetosOffGridActions, projetosOffGridState.geracao_necessaria_kw, projetosOffGridState.regioes])
 
  useEffect(() => {
    if (!projetosOffGridState.regioes.length) return;

    projetosOffGridActions.changeValue({ listagem_baterias_status: false })

    componenteProvider.buscarBateriasPorRegiao(
      projetosOffGridState.regioes, 
      "off",
    ).then(response => {
      
      if (response.statusCode !== STATUS_CODE.OK) {
        notifierStore.setNotifier({
          content: response.message || 'Erro ao buscar baterias.',
          onClose: () => notifierStore.setOpen(false),
          timeOut: 4000,
          title: "Atenção"
        })

        notifierStore.setOpen(true)
        return;
      }

      projetosOffGridActions.changeValue({ baterias: response.data, listagem_baterias_status: true })
      projetosOffGridActions.limparCiclosBateriaSeIncompativel()
    }).catch((err) => {
      //TO DO: Verificar tratamento de erro
    })

  }, [projetosOffGridActions, projetosOffGridState.regioes])

  useEffect(() => {
    if (!projetosOffGridState.regioes.length || !projetosOffGridState?.modulo_selecionado || !projetosOffGridState.geracao_necessaria_kw) return;

    const moduloSelecionado = projetosOffGridState?.modulo_selecionado;
    if (moduloSelecionado?.componente_id) {
      buscarEstruturasPorModulo({
        moduloId: moduloSelecionado.componente_id,
        potencia: projetosOffGridState.geracao_necessaria_kw,
        regioesId: projetosOffGridState.regioes
      }).then(response => {
        projetosOffGridActions.changeValue({ estruturas: response.retrato, todas_estruturas: response.todos })
      })
    }
  }, [projetosOffGridState?.modulo_selecionado, projetosOffGridState.geracao_necessaria_kw, projetosOffGridActions, projetosOffGridState.regioes])

  useEffect(()=>{
    if (projetosOffGridState.modulo_selecionado) {
      const moduloSelecionado = projetosOffGridState.modulos?.find(item => item.componente_id === projetosOffGridState.modulo_selecionado?.componente_id)
      if (!moduloSelecionado) {
        projetosOffGridActions.changeValue({ modulo_selecionado: null, estrutura_selecionada: null })
        projetosOffGridActions.changeValidationsValue({ modulo: { helper: "Módulo anterior removido: não permitido para esta UF", status: false } })
      } else {
        projetosOffGridActions.changeValidationsValue({ modulo: { helper: "", status: true } })
      }
    }
  },[projetosOffGridActions, projetosOffGridState.modulo_selecionado, projetosOffGridState.modulos])

  useEffect(()=>{
    if (projetosOffGridState.estrutura_selecionada) {
      const estruturaSelecionada = projetosOffGridState.estrutura_selecionada?.id ? projetosOffGridState.estruturas?.find(item => item.id === projetosOffGridState.estrutura_selecionada?.id && item.estruturas_grupo_id === projetosOffGridState.estrutura_selecionada?.estruturas_grupo_id) : true;
      const alterouValores = projetosOffGridState?.isTrocaUf || projetosOffGridState?.isTrocaModulo || projetosOffGridState?.isTrocaPotencia;
      const estruturaNaoEditada = !projetosOffGridState?.estrutura_selecionada?.editada && !projetosOffGridState.isEdit;
      const semEstruturaGrupo = !projetosOffGridState.estrutura_selecionada?.grupos?.length && projetosOffGridState.isEdit;
      const resultEstrutura = projetosOffGridState?.todas_estruturas?.find(estrutura => estrutura.id === projetosOffGridState.estrutura_selecionada?.id && estrutura?.grupos?.map(grupo => grupo?.id)?.includes(projetosOffGridState.estrutura_selecionada?.estruturas_grupo_id));

      if (!estruturaSelecionada && (estruturaNaoEditada || alterouValores || semEstruturaGrupo || !resultEstrutura)) {
        projetosOffGridActions.changeValue({ estrutura_selecionada: null })
        projetosOffGridActions.changeValidationsValue({ estrutura: { helper: "Estrutura anterior removida: não permitido para esta UF", status: false } })
      } else {
        projetosOffGridActions.changeValidationsValue({ estrutura: { helper: "", status: true } })

        const estruturas = projetosOffGridState.estruturas;
        const listaEstruturas =  [...estruturas];
        const estruturasIds = estruturas?.map(estrutura => estrutura.id);
        const estruturasGrupoIds = estruturas?.map(estrutura => estrutura.estruturas_grupo_id);
        if (projetosOffGridState?.estrutura_selecionada?.id && (!estruturasIds?.includes(projetosOffGridState?.estrutura_selecionada?.id) || (estruturasIds?.includes(projetosOffGridState?.estrutura_selecionada?.id) && !estruturasGrupoIds?.includes(projetosOffGridState?.estrutura_selecionada?.estruturas_grupo_id)))) {
          listaEstruturas.push(projetosOffGridState.estrutura_selecionada);
          projetosOffGridActions.changeValue({ estruturas: listaEstruturas });
        }
      }
    } else if (projetosOffGridState.isEdit && !projetosOffGridValidationsStoreState?.estrutura?.helper) {
      projetosOffGridActions.changeValidationsValue({ estrutura: { helper: "", status: false } })
    }
  },[projetosOffGridActions, projetosOffGridState.estrutura_selecionada, projetosOffGridState.estruturas, projetosOffGridState?.isTrocaUf, projetosOffGridState?.isTrocaModulo, projetosOffGridState?.isTrocaPotencia, projetosOffGridState?.isEdit, projetosOffGridValidationsStoreState?.estrutura?.helper, projetosOffGridState?.todas_estruturas])

  useEffect(()=>{
    if (!projetosOffGridState.cidade?.nome || !projetosOffGridState.estado?.id) return;

    getLatLngFromAddressDebounced({
      cep: projetosOffGridState.cep || '',
      cidadeNome: projetosOffGridState.cidade?.nome || '',
      estadoId: projetosOffGridState.estado?.id || '',
    })
  },[getLatLngFromAddressDebounced, projetosOffGridState.cep, projetosOffGridState.cidade, projetosOffGridState.estado])

  const comparaEstruturas = (antiga: ListagemItem[], atual: ListagemItem[])=>{
      if (antiga.length !== atual.length) return false;
      return antiga.every(itemAntigo => {
        const itemAtual = atual.find(a => a.componente_id === itemAntigo.componente_id);
        return itemAtual?.quantidade === itemAntigo?.quantidade;
      });
  }
  return (
      <>
      <Paper elevation={0}>
        <FormDadosOffGrid
          formState={projetosOffGridState}
          onChangeValue={(newState: any) => projetosOffGridActions.changeValue(newState)}
          errorState={errorState}
          onChangeError={(newErrorState: any) => setErrorState(newErrorState)}
          distribuidorRevendaUsuario={distribuidorRevendaUsuario}
          onClickNext={async() => {
            manualLoading$.next(true)

            const result: typeof projetosOffGridState = await captureData(projetosOffGridState)
            if (!result) {
              manualLoading$.next(false)
              return
            };
            const state = { ...result } 

            state.codigo_venda = result.codigo_venda
            state.recebe_servico = mostrarOpcaoServico

            const qtdModulosResult = await projetosOffGridProvider.calcularQtdModulos({
              moduloId: projetosOffGridState.modulo_selecionado?.componente_id || 0,
              potencia: projetosOffGridState.geracao_necessaria_w || 0,
            })

            if (qtdModulosResult.statusCode !== STATUS_CODE.OK) {
              notifierStore.setNotifier({
                content: qtdModulosResult.message || "Erro ao calcular quantidade de módulos.",
                onClose: () => notifierStore.setOpen(false),
                timeOut: 4000,
                title: "Atenção"
              })

              manualLoading$.next(false)
              notifierStore.setOpen(true)
              return;
            }

            state.potencia_fotovoltaica = qtdModulosResult.data?.potencia_fotovoltaica || 0;
            let qtdModulos = qtdModulosResult.data?.quantidade || 0
            
            if (state.modulo_selecionado) {
              state.modulo_selecionado = {
                ...state.modulo_selecionado,
                quantidade: qtdModulos,
              }
            }

            const solucaoCalculadaResponse = await projetosOffGridProvider.calcularSolucao({
              autonomia_bateria: Number(state.autonomia_banco_bateria || 0),
              regioes: projetosOffGridState.regioes,
              quantidade_modulos: state.modulo_selecionado?.quantidade || 0,
              potencia_fotovoltaica: state.potencia_fotovoltaica,
              consumo_total_diario: state.total_consumo_diario_w,
              tipo_bateria: state.tipo_bateria?.id || null,
              tensao_saida: state.tensao_saida?.id || '',
              potencia_equipamentos: calcularPotenciaEquipamentosOffGrid(projetosOffGridState.equipamentos || [])
            })

            if (solucaoCalculadaResponse.statusCode !== STATUS_CODE.OK) {
              notifierStore.setNotifier({
                content: solucaoCalculadaResponse.message,
                onClose: () => notifierStore.setOpen(false),
                timeOut: 4000,
                title: "Atenção"
              })
  
              manualLoading$.next(false)
              notifierStore.setOpen(true)
              return;
            }

            if (solucaoCalculadaResponse.data?.modulo?.alterouQuantidade && !!state.modulo_selecionado) {
              state.modulo_selecionado = {
                ...state.modulo_selecionado,
                quantidade: solucaoCalculadaResponse.data.modulo.quantidade || state.modulo_selecionado.quantidade || 0,
              }
              qtdModulos = solucaoCalculadaResponse.data.modulo.quantidade || state.modulo_selecionado.quantidade || 0
            }

            const calculoAcessorios = await calcularAcessorios({
              moduloId: state.modulo_selecionado?.componente_id || 0,
              regioes: projetosOffGridState.regioes,
              inversores: solucaoCalculadaResponse.data?.inversores || [],
              controladores: solucaoCalculadaResponse.data?.controladores || [],
              quantidade_modulos: state.modulo_selecionado?.quantidade || 0,
            })

            if (calculoAcessorios.statusCode !== STATUS_CODE.OK) {
              manualLoading$.next(false)
              return;
            } 

            const potenciaModulosEmWatts = state.modulo_selecionado ? (state.modulo_selecionado.quantidade * state.modulo_selecionado.potencia) : 0
            const potenciaModulosEmKiloWatts = potenciaModulosEmWatts ? DecimalUtil.toFixed(potenciaModulosEmWatts / 1000, 2) : 0
            const valorMinimoServicoResult = await projetosProvider.calcularValorMinimoServico(potenciaModulosEmKiloWatts, apiNoLoading);
            if (!solucaoCalculadaResponse.data || valorMinimoServicoResult.statusCode !== STATUS_CODE.OK) {
              notifierStore.setNotifier({
                content: valorMinimoServicoResult.message || "Erro ao calcular valor mínimo de serviço.",
                onClose: () => notifierStore.setOpen(false),
                timeOut: 4000,
                title: "Atenção"
              })

              manualLoading$.next(false)
              notifierStore.setOpen(true)
              return;
            }
            
            delete (state as Partial<typeof state>).solucao_calculada;
            projetosOffGridActions.addSolucaoCalculada(solucaoCalculadaResponse.data);

            const acessorios = calculoAcessorios.data || [];
            const oldAcessorios = state.acessorios || []
            if (acessorios.length > 0) {
              state.acessorios = acessorios.map(item=>{
                const oldQuantidade = oldAcessorios.find(oldItem => oldItem.componente_id === item.componente_id)?.quantidade || 0;
                const mantemAcessorio = ACESSORIOS_MANTIDOS_EDICAO.includes(item.categoria_componentes_id);

                return {
                  ...item,
                  quantidade: state.recalcular ? (mantemAcessorio ? oldQuantidade : (item.quantidade || 0)) : oldQuantidade
                }
              })
            }

            state.valor_minimo_servico = valorMinimoServicoResult.data?.valor_minimo_servico || 0;

            if (state.estrutura_selecionada) {
              const estruturaSelecionada = state.estrutura_selecionada?.id ? projetosOffGridState.estruturas?.find(item => item.id === state.estrutura_selecionada?.id) : elSemEstrutura;

              if (estruturaSelecionada) {
                const findGrupo = estruturaSelecionada.grupos?.find(g => g.id === estruturaSelecionada.estruturas_grupo_id) || estruturaSelecionada.grupos?.[0];
                let itemImageUrl = findGrupo?.url_imagem || estruturaSelecionada.url_imagem;

                if (estruturaSelecionada.id === 0) {
                  itemImageUrl = elSemEstrutura.url_imagem;
                }
         
                const fileirasPadrao = state.fileiras.length ? state.fileiras.length === 1 && state.fileiras[0].fileiras === 1 && state.fileiras[0].posicao_modulo?.value === 'retrato' : true;
                if (fileirasPadrao) {
                  state.fileiras = [{
                    fileiras: 1,
                    quantidade_modulos: qtdModulos,
                    tipo_estrutura: { image: itemImageUrl, text: estruturaSelecionada.nome, value: estruturaSelecionada.id, estruturas_grupo_id: estruturaSelecionada?.estruturas_grupo_id },
                    posicao_modulo: POSICAO_MODULO.find(item => item.value === 'retrato') || null,
                  }];
                } else if (estruturaSelecionada && !estruturaSelecionada.id) {
                  projetosOffGridActions.changeValidationsValue(
                    {fileiras: { status: false, helper: OFFGRID_ERROR_MESSAGES.FILEIRAS_INVALIDAS } }
                  )
                }

                if (estruturaSelecionada.id) {
                  const estruturaResult = await calcularEstruturas({
                    moduloId: projetosOffGridState.modulo_selecionado?.componente_id || 0,
                    controladores: solucaoCalculadaResponse.data?.controladores || [],
                    inversores: solucaoCalculadaResponse.data?.inversores || [],
                    fileiras: state.fileiras,
                    inversor: '',
                    potencia: state.geracao_necessaria_kw,
                    regioes: projetosOffGridState.regioes.map(Number),
                  })
                  oldEstruturas$.next(estruturaResult);
                  if (!comparaEstruturas(oldEstruturas, estruturaResult)){
                    state.estruturas_calculadas = estruturaResult;
                  }else {
                    state.estruturas_calculadas = projetosOffGridState.estruturas_calculadas || [];
                  }
                } else {
                  oldEstruturas$.next([])
                  state.estruturas_calculadas = [];
                }
              }
            }

            state.recalcular = false;
            state.isTrocaUf = false;
            state.isTrocaModulo = false;
            state.isTrocaPotencia = false;
            manualLoading$.next(false)
            onClickNext(state)
          }}
        />

      </Paper>
      <Prompt when={!!projetosOffGridState?.codigo_venda} message={(location) => {
        if (canNavigate(location)) return true;
        return `Deseja cancelar a ${projetosOffGridState?.isEdit ? 'edição' : 'criação'} do projeto?`
      }}/>

      {projetosOffGridModalsState.drawerInformacoes && <InformationDrawerOffGrid close={() => projetosOffGridActions.changeModalsValue({ drawerInformacoes: false })} isOpen={projetosOffGridModalsState.drawerInformacoes} />}
    </>
  )    
}
